import { combineReducers } from 'redux';

import { cancellationFailed } from './cancellationFailed/cancellationFailed';
import { duplicatedTaxPayment } from './duplicatedTaxPayment/duplicatedTaxPayment';
import { partnerModal } from './partnerModal/partnerModal';
import { paymentProof } from './paymentProof/paymentProof';
import { remainingBalancePaymentCreated } from './remainingBalancePaymentCreated/remainingBalancePaymentCreated';
import { tax } from './tax/tax';

const modals = combineReducers({
  duplicatedTaxPayment,
  tax,
  paymentProof,
  cancellationFailed,
  remainingBalancePaymentCreated,
  partnerModal,
});

export { modals };
